import { Component, OnInit } from '@angular/core';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
@Component({
  selector: 'app-transaction-list-layout',
  templateUrl: './transaction-list-layout.component.html',
  styleUrls: ['./transaction-list-layout.component.scss'],
})
export class TransactionListLayoutComponent implements OnInit {
  public transactionList: any = [];

  constructor(
    private tansactionService: TansactionService,
    private loginService: LoginSignupService
  ) {}

  ngOnInit(): void {
    this.tansactionService
      .getUserTransactionList()
      .then((data: any) => {
        this.transactionList = data.data;
        this.loginService.setUserData(data.user);

        //   if (this.transactionList?.length > 0) {
        //     if (this.transactionList[0]?.payment?.status === "authorized" || this.transactionList[0]?.payment?.status  =='captured') {
        //       this.localStorageService.setItem("plan",this.transactionList[0].plan);
        //       // environment.PLAN.ADVANCE.forEach(element => {
        //       //   if (transactionList[0].plan == element)
        //       //   this.localStorageService.setItem("plan","advance");
        //       // });
        //       // environment.PLAN.PREMIUM.forEach(element => {
        //       //   if (transactionList[0].plan == element)
        //       //   this.localStorageService.setItem("plan","premium");
        //       // });
        //     }
        // }
        // console.log(this.transactionList);
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
